import PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ModelTypeConstants from 'constants/ModelTypeConstants';

/**
 * Renders a faded span with an icon and item name
 */
function LabeledItem({icon, name, onClick, className}) {
  return (
    <span className={className} onClick={onClick}>
      <BenchlingIcon className="u-faded" icon={icon} />
      {` ${name}`}
    </span>
  );
}

LabeledItem.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

/**
 * Renders a span with a folder icon and folder name.
 */
function LabeledFolder({name, onClick, className}) {
  return <LabeledItem className={className} icon={ModelTypeConstants.FOLDER} name={name} onClick={onClick} />;
}

LabeledFolder.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default LabeledFolder;
